/**
 * enTour — the first-run tour's copy.
 *
 * Split out of `en.ts` because that file reached the 500-line ceiling the
 * `fileSize` ratchet enforces. The tour is a self-contained screen with its own
 * lifecycle, so it is a natural seam rather than an arbitrary cut: nothing else
 * reads these keys, and the per-kind first step lives here beside the default
 * one it varies from.
 */
export const enTour = {
  'tour.title': 'Welcome to BuzzBit X',
  'tour.skip': 'Skip tour',
  'tour.back': 'Back',
  'tour.next': 'Next',
  'tour.finish': 'Finish',
  'tour.showMe': 'Take me there',
  'tour.stepCount': 'Step {current} of {total}',
  'tour.step1.title': 'Connect your store',
  'tour.step1.body':
    'Link your Shopify store under Account → Integrations. Once connected, your products, customers, and orders sync automatically — you should see your products under Products within a minute.',
  // Course, SaaS, coaching and content creator: no store to connect either.
  'tour.step1Other.title': 'Connect what your business already uses',
  'tour.step1Other.body':
    'Under Account → Integrations, connect the tools your business already runs on. Every person who buys, books, enrolls or subscribes becomes a record you can follow up.',
  // Services: there is no store to connect, and the first useful thing is the
  // link that fills the calendar.
  'tour.step1Service.title': 'Put your booking link where people will use it',
  'tour.step1Service.body':
    'Your Business Hub carries a share link that takes bookings straight onto your calendar — put it in your bio, your emails, or on a sign. Every booking becomes a client record you can follow up.',
  'tour.step2.title': 'Turn on your first flow',
  'tour.step2.body':
    'Open Automations and activate a starter flow. An active flow shows a green "Active" badge — that is how you know it is live.',
  'tour.step3.title': 'Connect a channel and meet your Inbox',
  'tour.step3.body':
    'Connect WhatsApp, Instagram, or Messenger under Account → Integrations. Customer messages land in the Inbox, and campaign results appear in Analytics.',} as const;
